import { SVGProps } from 'react';

const Github = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M9 22v-4c-.07-.62-.02-1.25.15-1.85s.46-1.16.85-1.65c-3 0-6-2-6-5.5a5.4 5.4 0 0 1 1-3.5C4.7 4.35 4.7 3.15 5 2c0 0 1 0 3 1.5 2.64-.5 5.36-.5 8 0C18 2 19 2 19 2c.28 1.15.28 2.35 0 3.5A5.4 5.4 0 0 1 20 9c0 3.5-3 5.5-6 5.5a4.8 4.8 0 0 1 1 3.5v4m-6-4c-4.51 2-5-2-7-2"
    />
  </svg>
);
export default Github;
